<template>
  <span>
    <qrcode-vue :value=url size=150 />
  </span>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  props: {
    url: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      show: false,
    };
  },
  components: {
    QrcodeVue,
  },
  computed: {

  },
  methods: {
  },
  created() {
  }
};
</script>
